import React from 'react';
import omLogo from '../../../assets/old_mutual_logo.png';
import simplyLogo from '../Logo/simply.png';
import simplyLogoWhite from '../Logo/simply-white.svg';
import Facebook from '../../../assets/facebook.svg';
import Twitter from '../../../assets/twitter.svg';
import Instagram from '../../../assets/instagram.svg';
import Youtube from '../../../assets/youtube.svg';
import { socialLinks, contactDetails, linkGroupConfig } from '../../../constants';
import { convertLinkGroup, wrapAssetPath } from '../../../utils';
export var copywriter = function copywriter(theme) {
  return {
    info: 'Copyright ' + new Date().getFullYear() + ' Simply Financial Services (Pty) Ltd. All rights reserved. Simply is a registered financial services provider (FSP: ' + contactDetails.fsp + ').',
    logo: wrapAssetPath(theme, simplyLogo)
  };
};
export var underwriter = function underwriter(theme) {
  return {
    info: 'The underwriter of this policy is Old Mutual Alternative Risk Transfer Limited (OMART) a registered long-term insurer.',
    logo: wrapAssetPath(theme, omLogo)
  };
};
export var address = function address(theme) {
  return {
    logo: wrapAssetPath(theme, simplyLogoWhite),
    lines: '<h5>' + contactDetails.address.company + '</h5>\n      <p>' + contactDetails.address.building + ',\n      ' + contactDetails.address.street + ', ' + contactDetails.address.suburb + ',\n      ' + contactDetails.address.city + ',<br />\n      ' + contactDetails.address.postalCode + '</p>\n    ',
    contactNumbersHtml: '<p><span className="h5">Quotes/Sales:</span> <a href=\'tel:' + contactDetails.numbers.callcenter27 + '\'>' + contactDetails.numbers.callcenter + '</a><br />\n    <span className="h5">Helpline:</span> <a href=\'tel:' + contactDetails.numbers.help27 + '\'>' + contactDetails.numbers.help + '</a></p>',
    socialLinks: [{
      href: socialLinks.facebookUrl,
      img: wrapAssetPath(theme, Facebook)
    }, {
      href: socialLinks.twitterUrl,
      img: wrapAssetPath(theme, Twitter)
    }, {
      href: socialLinks.instagramUrl,
      img: wrapAssetPath(theme, Instagram)
    }, {
      href: socialLinks.youtubeUrl,
      img: wrapAssetPath(theme, Youtube)
    }]
  };
}; // COLUMNS

export var generateColumns = function generateColumns(f) {
  return [[convertLinkGroup(f, linkGroupConfig.products)], [convertLinkGroup(f, linkGroupConfig.whoweare)], [convertLinkGroup(f, linkGroupConfig.help), convertLinkGroup(f, linkGroupConfig.legal)]];
};
export default generateColumns;